/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_No_TimerInputs */



/**
* | output |
* | --- |
* | "No timer" |
*
* @param {Timer_No_TimerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_no_timer = /** @type {((inputs?: Timer_No_TimerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_No_TimerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de chronomètre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin temporizador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem temporizador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun timer")
	return /** @type {LocalizedString} */ ("No timer")
});